import { get } from 'svelte/store';

import { USER_DATA_DEFAULT } from 'src/constants';
import { clearCameraStores } from 'src/components/Camera/helpers/camera-helpers';
import { resetSubUnitsCache } from 'src/components/Scenes/helpers/notification_recipients_helpers';

import { home_data, profile_data, user_data, user_settings } from './account/user';
import { clearHomes } from './account/home';
import { aiSceneChatStore } from './features/ai-scene-chat';
import { dashboards } from './features/dashboards';
import {
	device_auths,
	auth_locked_devices,
	auth_unlocked_at,
	req_locked_devices,
} from './device-runtime/local-auth';
import {
	firmwares,
	firmwares_gen_2,
	rebooting_devices,
	updating_devices,
} from './device-runtime/process';
import { devices_settings, devices_status } from './device-runtime/status';
import { deviceRuntimeResource } from './device-runtime/resource-state';
import { clearDeviceRuntimeSelectorCaches } from './device-runtime/status-selectors';
import { deviceRuntimeDiagnostics } from './features/dev/device-runtime-diagnostics';
import { stackedMobileEvents } from './features/ai-model';
import { resetEditUpdateStore } from './ui/edit_lists';
import { scenes } from './lists/scenes';
import { devices } from './lists/devices';
import { groups } from './lists/groups';
import { rooms } from './lists/rooms';
import { alerts_list } from './session/alerts-onboarding';
import {
	alarm_object,
	device_object,
	list_of_color,
	scene_object,
	temp_scene_el,
	temp_scheme_object,
	tmp_thermostat,
} from './wizards';

/**
 * Single entry point for clearing Svelte stores on logout / account delete.
 * @see docs/todo/stores-refactor.md
 */
export function resetAllStores(): void {
	user_data.set({ ...USER_DATA_DEFAULT, lang: get(user_settings).lang });
	user_settings.set({ lang: get(user_settings).lang });
	home_data.set({});
	profile_data.set({});

	devices.reset();
	rooms.reset();
	groups.reset();
	scenes.reset();
	dashboards.reset();
	devices_status.reset();
	devices_settings.reset();
	deviceRuntimeDiagnostics.clear();
	deviceRuntimeResource.reset();
	clearDeviceRuntimeSelectorCaches();

	list_of_color.reset();
	device_auths.reset();
	/** On log out set alerts to {} — otherwise login with no alerts throws errors. */
	alerts_list.set({});

	firmwares.reset();
	firmwares_gen_2.reset();
	updating_devices.reset();
	rebooting_devices.set([]);
	req_locked_devices.set([]);
	auth_locked_devices.set([]);
	auth_unlocked_at.reset();

	device_object.reset();
	scene_object.reset();
	temp_scheme_object.reset();
	alarm_object.reset();
	temp_scene_el.reset();
	tmp_thermostat.reset();

	resetEditUpdateStore();
	stackedMobileEvents.set([]);

	aiSceneChatStore.clearAllData();
	clearCameraStores();
	clearHomes();
	resetSubUnitsCache();
}
